module.exports = __webpack_public_path__ + "static/img/center_img6.663daf45.png";